export const legendItems = [
  { label: "عالی", colorClass: "before:bg-success-600" },
  { label: "خوب", colorClass: "before:bg-secondary-600" },
  { label: "قابل قبول", colorClass: "before:bg-[#FF6A00]" },
  { label: "نیاز به تلاش", colorClass: "before:bg-[#D92D20]" },
  { label: "نامشخص", colorClass: "before:bg-[#98A2B3]" }
];
